import React, { useEffect } from 'react';
import ProductSelectorAutocomplete from '../products/productselectorautocomplete';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormLabel,
    IconButton,
    Radio,
    RadioGroup,
    useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import NewProductRequiredView from '../products/newproductrequiredview';
import { useTranslation } from 'react-i18next';

const closeButtonStyle = {
    position: 'absolute',
    right: 1,
    top: 1,
    color: 'grey.500',
};

function MyDialogTitle({ onClose, title }) {
    return (
        <DialogTitle id="simple-dialog-title">
            {title}
            <IconButton aria-label="close" sx={closeButtonStyle} onClick={onClose}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>
    );
}

export default function FilterProductChangeDialog(props) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [title, setTitle] = React.useState('');
    const [showNewProdEdit, setShowNewProdEdit] = React.useState(false);
    const [replaceType, setReplaceType] = React.useState('filter');
    const { t } = useTranslation();

    useEffect(() => {
        if (!!props.title) setTitle(props.title);
        else setTitle(t('location.replaceFilter.pickNewFilter'));
    }, [props.show, props.title, t]);

    const handleClose = () => {
        props.selected(null);
    };

    const newProduct = () => {
        setShowNewProdEdit(true);
        setTitle(t('location.replaceFilter.newFilterProduct'));
    };

    const cancel = () => {
        setShowNewProdEdit(false);
        setTitle(t('location.replaceFilter.pickNewFilter'));
    };

    const onChangeReplaceType = (e) => {
        setReplaceType(e.target.value);
    };

    const selected = (productId) => {
        props.selected(productId, replaceType);
    };

    return (
        <Dialog
            onClose={handleClose}
            aria-labelledby="simple-dialog-title"
            open={props.show}
            fullWidth={true}
            maxWidth={'md'}
            fullScreen={fullScreen}>
            <MyDialogTitle onClose={handleClose} title={title} />
            <DialogContent>
                <FormControl>
                    <FormLabel id="replace-selection-switch">{t('location.replaceFilter.typeTitle')}</FormLabel>
                    <RadioGroup
                        aria-labelledby="replace-selection-switch"
                        defaultValue="filter"
                        onChange={onChangeReplaceType}
                        name="radio-buttons-group">
                        <FormControlLabel
                            value="filter"
                            control={<Radio name="radio-filter" />}
                            label={t('location.replaceFilter.typeFilter')}
                        />
                        <FormControlLabel
                            value="machine"
                            control={<Radio name="radio-machine" />}
                            label={t('location.replaceFilter.typeMachine')}
                        />
                        <FormControlLabel
                            value="location"
                            control={<Radio name="radio-location" />}
                            label={t('location.replaceFilter.typeLocation')}
                        />
                    </RadioGroup>
                </FormControl>
                {!showNewProdEdit && (
                    <ProductSelectorAutocomplete
                        dismiss={handleClose}
                        selected={selected}
                        allowNewProd={props.allowNewProd}
                        newProduct={newProduct}
                        showBundles={true}
                    />
                )}
                {showNewProdEdit && (
                    <NewProductRequiredView
                        selected={selected}
                        cancel={cancel}
                        productRequestHint={props.productRequestHint}
                    />
                )}
            </DialogContent>
        </Dialog>
    );
}
